import { isVersionedSimPathEnabled, getCachedSimVersion } from './getSimVersion';

export default function getWebglLink(caseId, orgId) {
    const { origin } = window.location;
    // Emit the versioned launch path only when the feature is enabled AND a version
    // has been resolved; otherwise fall back to the legacy unversioned path (also the
    // safe cold-start behaviour before the first /sim-version fetch resolves).
    const version = isVersionedSimPathEnabled() ? getCachedSimVersion() : null;
    const base = version ? `${origin}/sim/${version}/` : `${origin}/sim`;
    return `${base}?case=${caseId}&org=${orgId}`;
}
